<template>
  <transition name="fade">
    <div class="searching" v-show="view">
      <button id="close-search" @click="closeSearch"><i class="fa fa-times"></i></button>
      <p class="txt-search">Realizá tu búsqueda</p>
      <input class="modal-search__input" id="buscador" @keyup="searching" v-model="query" type="text" autocomplete="off" placeholder="¿Qué buscás?">
      <div class="result" v-show="results.length > 0">
        <ProductSearchComponent :word="query" v-for="(result,k) in results" :data="$parent.productsData[result.sku]" :key="k"/>
      </div>
      <div class="legend" v-show="results.length < 1 && legend !== ''" v-html="legend"></div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable */
import ProductSearchComponent from './ProductSearchComponent'

export default {
  name: 'Product',
  methods: {
    searching(){
    	this.query = this.query.toLowerCase()
    	if (this.query.length > 3) {
    		this.results = []
    		Object.entries(this.$parent.productsData).forEach( product => {
    			if (product[1].keywords.indexOf(this.query) !== -1) {
    				this.results.push(product[1])
    			}
    		})
    		if (this.results.length < 1) {
    			this.legend = 'No se encontraron productos con el término <strong>"' + this.query + '"</strong>. Encontrá más en <a href="https://easy.com.ar">Easy.com.ar</a>'
    		}
    	} else {
    		this.results = []
    	}
    },
    closeSearch () {
    	this.$parent.viewSearch = false
      if (window.screen.width < 1000) {
  		  document.body.style.overflow = 'auto'
      }
    }
  },
  data () {
    return {
      results: [],
      query: '',
      legend: ''
    }
  },
  props: {
    view: Boolean
  },
  components: {
    ProductSearchComponent
  }
}
</script>
<style>
.searching{position:fixed;top:0px;z-index:200;background:rgba(255,255,255,.95);height: 100vh;
overflow: auto;}
#close-search{background:#E0172F;width:15%;z-index:11;border:0px;color:#fff;font-size:3em;position:fixed;right:0px;}
.searching .txt-search{display:none;}
input{background:#fff;border:solid thin #ccc;width:79%;padding:10px 3%;border:0px;font-size:1em;position:fixed;z-index:11;left:0px;top:0px;height: 36px;
border-bottom: solid thin #ccc;}
.result{padding-top:60px;}
.result .product-card{display:inline-block;width:80%;vertical-align:top;margin:10px;height:500px}
.legend {
    font-size: 1em;
    padding-top: 103px;
    font-family: 'Open Sans';
}
@media only screen and (min-width: 1000px) {
  .searching{position:absolute!important;width:100%;height:100vh;z-index:11;background-color:rgba(255,255,255,.95)}
  #close-search{position:absolute;top:30px;right:30px;font-size:2.500em;color:#000;background:none;border:0px;cursor:pointer}
  .txt-search{font-size:24px;margin-top:10vh}
  input{position:relative;background:#fff;border:solid thin #ccc;border-radius:10px;width:40%;padding:15px;font-size:18px;top:10vh;}
  .result{width:80%;margin:20px auto!important;height:70vh;overflow-y:auto;padding:0px !important;margin-top:100px!important;}
  .result .product-card{display:inline-block;max-width:200px;height:425px!important;vertical-align:top;margin:10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/SearchComponent.vue